module.exports = __webpack_public_path__ + "img/astral_25.92dbdd3d.svg";